'use strict';
var ajax = require('../ajax'),
	util = require('../util'),
	validator = require('../validator'),
	progress = require('../progress'),
	dialog = require('../dialog'),
	TPromise = require('promise'),
	address = require('./checkout/address'),
	formPrepare = require('./checkout/formPrepare'),
	loqate = require('../loqate'),
	linchpinAccount = require('int_googletagmanager/linchpin/account'),
	linchpinSubscription = require('int_googletagmanager/linchpin/subscription');

/**
 * @function
 * @description Initializes the events on the address form dialog popup (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm () {
	// Removes focus from select drop-down list when overlay is clicked
	$('.ui-widget-overlay').bind('click', function () {
		$('select').each(function () {
			$(this).blur();
		});
	});

	var $form = $('#edit-address-form');
	$form.find('select').uniform();
	$form.find('input[name="format"]').remove();

	address.dynamicAddressFieldsHandler($form);
	formPrepare.init({
		continueSelector: '[name$="_address_create"]',
		formSelector: $form,
		replaceInvalidInput: true,
		keyup: false,
		autofillValidate: true
	});
	loqate.init($form);
	validator.initForm($form);

	$form.on('click', '.apply-button', function (e) {
		var action = $(this).data('action');
		e.preventDefault();
		if (!$form.valid()) {
			return false;
		}
		$('<input/>').attr({
			name: $(this).attr('name'),
			type: 'hidden'
		}).appendTo($form);

		var options = {
			url: $form.attr('action'),
			data: $form.serialize() + '&format=ajax',
			type: 'POST'
		};

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpinAccount.addNewAddressEvent(e);
			linchpinSubscription.triggerAddressChangeEvent();
		}
		progress.show($('#addresses'));
		$.ajax(options).always(function (data) {
			if (data && data.success) {
				dialog.close();
				ajax.load({
					url:util.ajaxUrl(Urls.addressesList),
					target:$('#addresses'),
					callback: function () {
						progress.hide();
						addressListUpdateCallback(action, e);
					}
				});
			} else {
				// update content with validated form HTML
				var formValidated = $(data).filter("#edit-address-form");
				$form.html(formValidated.html());
				// init events
				$form.find('.enter-manually').trigger('click');
				address.dynamicAddressFieldsHandler($form);
				formPrepare.init({
					continueSelector: '[name$="_address_create"]',
					formSelector: $form,
					replaceInvalidInput: true,
					keyup: false
				});
				loqate.init($form);
				progress.hide();
			}
		});
	})
	.on('click', '.cancel-button, .close-button', function (e) {
		e.preventDefault();
		dialog.close();
	});
}

/**
 * @private
 * @function
 * @description displays warning message based on action and re-int UI event handlers
 */
function addressListUpdateCallback (action, e) {
	var statusBar = $('#addresses .action-status-msg'),
		defualtMessage = '<p>' + Resources.ADDRESS_UPDATED_MSG + '</p>',
		msg;

	switch (action) {
		case 'add':
			msg = defualtMessage;
			break;
		case 'delete':
			msg = defualtMessage;
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpinAccount.removeAddressEvent(e);
			}
			break;
		case 'make-primary':
			msg = '<p>' + Resources.ADDRESS_BILLING_UPDATED_MSG + '</p>';
			break;
		case 'make-default':
			msg = '<p>' + Resources.ADDRESS_SHIPPING_UPDATED_MSG + '</p>';
			break;
		default:
			msg = defualtMessage;
	}
	statusBar.addClass('active').html(msg).show(400);

	$('.toggle-title').on('click touchstart', function (e) {
		$(this).toggleClass('on').next('.toggleContent').toggleClass('show');
		e.preventDefault();
	});
}
/**
 * @private
 * @desc constructs confirmation dialog based on action is being confirmed
 */
function confirmAction (action) {
	var title,
		content;
	switch (action) {
		case 'delete':
			title = Resources.REMOVE_ADDRESS_TITLE;
			content = Resources.REMOVE_ADDRESS_MESSAGE;
			break;
		case 'make-default':
			title = Resources.SET_DEFAULT_ADDRESS_TITLE;
			content = Resources.SET_DEFAULT_ADDRESS_MESSAGE;
			break;
		case 'make-primary':
			title = Resources.SET_PRIMARY_ADDRESS_TITLE;
			content = Resources.SET_PRIMARY_ADDRESS_MESSAGE;
	}
	return new TPromise(function (resolve, reject) {
		dialog.open({
			html: $('<p>' + content + '</p>'),
			options: {
				title: title,
				dialogClass: 'yes-and-no-dialog',
				buttons: [
					{
						text: Resources.NO,
						click: function () {
							reject();
							dialog.close();
						},
						'class':'button-gray'
					},
					{
						text: Resources.YES,
						click: function () {
							dialog.close();
							resolve();
						},
						'class':'button-black'
					}
				]
			}
		});
	});
}
/**
 * @function
 * @description Init address book events
 */
exports.init = function () {

	$('#addresses').on('click', '.address-edit, .address-create',  function (e) {
		e.preventDefault();
		dialog.open({
			url: this.href,
			options: {
				buttons:[],
				dialogClass: 'shipping-address-dialog addressbook',
				open: function () {
					initializeAddressForm();
				}
			}
		});
	}).on('click', '.address-make-default, .address-make-primary, .address-delete', function (e) {
		var action = $(this).data('action'),
			url = $(this).attr('href');

		e.preventDefault();
		confirmAction(action).then(function () {
			progress.show('#addresses');
			ajax.load({
				url:url,
				target:$('#addresses'),
				callback: function () {
					progress.hide();
					addressListUpdateCallback(action, e);
				}
			});
		});
	});
};
